// Apple Pay adapter implementing the WalletAdapter port.
//
// The port contract (duck-typed):
//   walletType: string
//   extractWalletToken(event): string        // base64-encoded vendor payload
//   extractCardHolder(event): string | undefined
//   extractBillingData(config, event): object  // one-time customerData shape

function extractCardHolder(event) {
  const billing = event?.payment?.billingContact || {};
  const full = `${billing.givenName || ""} ${billing.familyName || ""}`.trim();
  return full || undefined;
}

function extractBillingData(config, event) {
  const billing = event?.payment?.billingContact || {};
  const lines = billing.addressLines || [];
  const customerData = config?.customerData || {};

  return {
    firstName: customerData.firstName,
    lastName: customerData.lastName,
    customerNumber: customerData.customerNumber,
    billingEmail: customerData.billingEmail,
    billingAddress1: lines[0] || "",
    billingAddress2: lines[1] || "",
    billingCity: billing.locality || "",
    billingState: billing.administrativeArea || "",
    billingZip: billing.postalCode || "",
    billingCountry: billing.country || "",
  };
}

function extractWalletToken(event) {
  return btoa(JSON.stringify(event?.payment));
}

export const applePayAdapter = {
  walletType: "apple_pay",
  extractWalletToken,
  extractCardHolder,
  extractBillingData,
};
